// constants
import { RepairType } from './constants';

export type RepairActionType = {
    type:
        | RepairType.API_RESPONSE_SUCCESS
        | RepairType.API_RESPONSE_ERROR
        | RepairType.RESET
        | RepairType.REPAIR_RECE
        | RepairType.UPD_REPAIR_RECE
        | RepairType.REPAIR_SEND
        | RepairType.UPD_REPAIR_SEND
        | RepairType.REPAIR_RETURN
        | RepairType.UPD_REPAIR_RETURN
        | RepairType.REPAIR_HANDOVER
        | RepairType.UPD_REPAIR_HANDOVER
    payload: {} | string;
};

export const repairsuccess = (actionType: string, data:any): RepairActionType => ({
    type: RepairType.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const repairerrors = (actionType: string, error: string): RepairActionType => ({
    type: RepairType.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const addRepairReceive = (entrydate,customerid,details,name,phone,address,phonecode,voucherdetdata): RepairActionType => ({
    type: RepairType.REPAIR_RECE ,
    payload: {entrydate,customerid,details,name,phone,address,phonecode,voucherdetdata},
});
export const updRepairReceive = (id,entrydate,customerid,details,name,phone,address,phonecode,voucherdetdata): RepairActionType => ({
    type: RepairType.UPD_REPAIR_RECE ,
    payload: {id,entrydate,customerid,details,name,phone,address,phonecode,voucherdetdata},
});
export const addRepairSend = (entrydate,supplierid,details,voucherdetdata): RepairActionType => ({
    type: RepairType.REPAIR_SEND,
    payload: {entrydate,supplierid,details,voucherdetdata},
});
export const updRepairSend = (id,entrydate,supplierid,details,voucherdetdata): RepairActionType => ({
    type: RepairType.UPD_REPAIR_SEND,
    payload: {id,entrydate,supplierid,details,voucherdetdata},
});
export const addRepairReturn = (entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata): RepairActionType => ({
    type: RepairType.REPAIR_RETURN,
    payload: {entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata},
});
export const updRepairReturn = (id,entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata): RepairActionType => ({
    type: RepairType.UPD_REPAIR_RETURN,
    payload: {id,entrydate,supplierid,paymethod,postentry,bankid,reference,amount,voucherdetdata},
});
export const addRepairHandover = (entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata): RepairActionType => ({
    type: RepairType.REPAIR_HANDOVER,
    payload: {entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata},
});
export const updRepairHandover = (id,entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata): RepairActionType => ({
    type: RepairType.UPD_REPAIR_HANDOVER,
    payload: {id,entrydate,customerid,phone,name,address,paymethod,postentry,bankid,reference,amount,phonecode,voucherdetdata,sparepartdata},
});

export const resetRepair = (): RepairActionType => ({
    type: RepairType.RESET,
    payload: {},
});

